import React from 'react'
import {
    Flex,
    Stat,
    StatLabel,
    StatNumber,
    useColorModeValue,
    Box,
    Text
} from "@chakra-ui/react";
import { TrendUp } from "phosphor-react";

export const MiniStatistics = ({ title, amount, percentage, icon }) => {
    const iconTeal = useColorModeValue("teal.300", "teal.300");
    const textColor = useColorModeValue("gray.700", "white");

    return (
        <Box backgroundColor={"white"} width={"100%"} padding={"25px"} height={"100px"} margin={2} borderRadius={"15px"} flex={1}>

            <Flex flexDirection='row' align='center' justify='center' w='100%'>
                <Stat me='auto'>
                    <StatLabel
                        fontSize='sm'
                        color='gray.400'
                        fontWeight='bold'
                        pb='4px'>
                        {title}
                    </StatLabel>
                    <Flex>
                        <StatNumber fontSize='lg' color={textColor}>
                            {amount}
                        </StatNumber>
                        <Box marginLeft={"2"} display={"flex"}>

                            <TrendUp size={18} weight='fill' color='green' />
                            <Text
                                marginLeft={"1"}
                                as='span'
                                color={percentage > 0 ? "green.400" : "red.400"}
                                fontWeight='bold'>
                                {`${percentage}`}
                            </Text>{" "}
                        </Box>
                    </Flex>
                </Stat>
                <Box as='box' h={"45px"} w={"45px"} display={"flex"} justifyContent={"center"} alignItems={"center"} bg={iconTeal}>
                    {icon}
                </Box>
            </Flex>

        </Box>
    )
}
